module.exports = __webpack_public_path__ + "img/linse_samlet_raa.7fd1bb15.jpg";